import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import { bindActionCreators} from 'redux'
import PropTypes from 'prop-types'
import {Tab, Table, Label, Button} from 'semantic-ui-react'
import {
    setContactModelInStore
} from '../../../actions/relation'
import ContactModalForm from '../../forms/relations/ContactModal'

class ContactTab extends Component {
    constructor() {
        super();
        this.state = {
            formOpen: false
        }
    }

    onContactEditClick = (contact) => {
        this.props.setContactModelInStore(contact, this.props.relationId);
        this.setState({
            formOpen: true
        })
    }

    onAddNewClick = () => {
        this.props.setContactModelInStore({}, this.props.relationId);
                this.setState({
            formOpen: true
        })
    }

    render() {
        const {contacts} = this.props;
        return (
            <Tab.Pane>
                <Table compact>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Title</Table.HeaderCell>
                            <Table.HeaderCell>Dpt.</Table.HeaderCell>
                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>Status</Table.HeaderCell>
                            <Table.HeaderCell>Phone</Table.HeaderCell>
                            <Table.HeaderCell>Fax</Table.HeaderCell>
                            <Table.HeaderCell>Email</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {_.isArray(contacts) ? contacts.map( i => {
                            return (
                                <Table.Row key={i.id}>
                                    <Table.Cell>{i.title}</Table.Cell>
                                    <Table.Cell>{i.department}</Table.Cell>
                                    <Table.Cell>
                                        <a href="javascript:;" onClick={() => {this.onContactEditClick(i)}}>
                                            {i.name}
                                        </a>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {i.status === 'Active' ? <Label circular color='green' empty size='mini' /> : 
                                            <Label circular color='red' empty size='mini' />
                                        }
                                    </Table.Cell>
                                    <Table.Cell>
                                        {i.phone}
                                    </Table.Cell>
                                    <Table.Cell>{i.fax}</Table.Cell>
                                    <Table.Cell>{i.email}</Table.Cell>
                                </Table.Row>
                            )
                        }): null}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='7'>
                                <Button size='mini' 
                                    floated='right' 
                                    onClick={() => {this.onAddNewClick()}}
                                    color='teal' as={Button}>Add New</Button>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
                <ContactModalForm 
                    isOpen={this.state.formOpen}
                    onModalClose={() => {this.setState({formOpen: false})}}
                />
            </Tab.Pane>
        )
    }
}

ContactTab.propTypes = {
    contacts: PropTypes.array.isRequired,
    relationId: PropTypes.number.isRequired,
    setContactModelInStore: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setContactModelInStore
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactTab)


// WEBPACK FOOTER //
// ./src/components/relations/parts/ContactTab.js